"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ShapeLogo = exports.ShapeLogoDefaultProps = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var icon_1 = require("./icon");
var use_app_options_1 = require("../../hooks/use-app-options");
exports.ShapeLogoDefaultProps = {
  isSmall: false
};
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    margin: 0;\n    color: ", ";\n    text-decoration: none;\n    display: flex;\n    align-items: center;\n    font-size: ", ";\n\n    ", "\n  \n  "], ["\n    margin: 0;\n    color: ", ";\n    text-decoration: none;\n    display: flex;\n    align-items: center;\n    font-size: ", ";\n\n    ", "\n  \n  "])), theme_1.theme.COLOR('dark'), theme_1.theme.FONT_SIZE(14), function (props) {
    return props.isSmall && (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      font-size: ", ";\n    "], ["\n      font-size: ", ";\n    "])), theme_1.theme.FONT_SIZE(12));
  }),
  tablet: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    font-size: ", ";\n\n    ", "\n\n  "], ["\n    font-size: ", ";\n\n    ", "\n\n  "])), theme_1.theme.FONT_SIZE(16), function (props) {
    return props.isSmall && (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      font-size: ", ";\n    "], ["\n      font-size: ", ";\n    "])), theme_1.theme.FONT_SIZE(16));
  }),
  desktopLarge: (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    font-size: ", ";\n\n    ", "\n\n  "], ["\n    font-size: ", ";\n\n    ", "\n\n  "])), theme_1.theme.FONT_SIZE(20), function (props) {
    return props.isSmall && (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n      font-size: ", ";\n    "], ["\n      font-size: ", ";\n    "])), theme_1.theme.FONT_SIZE(16));
  })
});
var ShapeLabelStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    font-weight: 500;\n    text-decoration: none;\n  "], ["\n    font-weight: 500;\n    text-decoration: none;\n  "]))),
  tablet: (0, styled_components_1.css)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    display: inline;\n  "], ["\n    display: inline;\n  "])))
});
var PlatformLabelStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    font-weight: 300;\n    text-decoration: none;\n  "], ["\n    font-weight: 300;\n    text-decoration: none;\n  "])))
});
var IconStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n    margin-top: 1px;\n    flex-shrink: 0;\n    margin-right: ", ";\n    width: 14px;\n    height: 14px;\n\n    ", "\n\n    svg {\n      width: 100%;\n      height: 100%;\n    }\n\n  "], ["\n    margin-top: 1px;\n    flex-shrink: 0;\n    margin-right: ", ";\n    width: 14px;\n    height: 14px;\n\n    ", "\n\n    svg {\n      width: 100%;\n      height: 100%;\n    }\n\n  "])), theme_1.theme.UNIT(2), function (props) {
    return props.isSmall && (0, styled_components_1.css)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n      display: none;\n    "], ["\n      display: none;\n    "])));
  }),
  tablet: (0, styled_components_1.css)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n    width: 18px;\n    height: 18px;\n    display: block;\n\n  "], ["\n    width: 18px;\n    height: 18px;\n    display: block;\n\n  "]))),
  desktopLarge: (0, styled_components_1.css)(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n    width: 32px;\n    height: 32px;\n  "], ["\n    width: 32px;\n    height: 32px;\n  "])))
});
// -------- Components -------->
var My = {
  Container: styled_components_1.default.h1(templateObject_14 || (templateObject_14 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Icon: (0, styled_components_1.default)(icon_1.Icon)(templateObject_15 || (templateObject_15 = __makeTemplateObject(["", ""], ["", ""])), IconStyles),
  ShapeLabel: styled_components_1.default.b(templateObject_16 || (templateObject_16 = __makeTemplateObject(["", ""], ["", ""])), ShapeLabelStyles),
  PlatformLabel: styled_components_1.default.span(templateObject_17 || (templateObject_17 = __makeTemplateObject(["", ""], ["", ""])), PlatformLabelStyles)
};
var ShapeLogo = function (props) {
  var className = props.className,
    iconColor = props.iconColor,
    icon = props.icon,
    isSmall = props.isSmall;
  var appOptions = (0, use_app_options_1.useAppOptions)();
  // @ts-ignore
  var platformLabel = props.platformLabel || appOptions.shapeLogoLabel || 'platform';
  // @ts-ignore
  var IconComponent = icon || appOptions.shapeLogoIcon;
  // @ts-ignore
  var color = iconColor || appOptions.shapeLogoIconColor || 'yellow-orange';
  return react_1.default.createElement(My.Container, {
    isSmall: isSmall,
    className: className
  }, IconComponent && react_1.default.createElement(My.Icon, {
    size: isSmall ? 18 : 24,
    isSmall: isSmall,
    color: color
  }, react_1.default.createElement(IconComponent, null)), !isSmall && react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement(My.ShapeLabel, {
    isSmall: isSmall
  }, "shape:"), react_1.default.createElement(My.PlatformLabel, {
    isSmall: isSmall
  }, platformLabel)));
};
exports.ShapeLogo = ShapeLogo;
exports.ShapeLogo.defaultProps = exports.ShapeLogoDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17;